import { useConfig } from '@@/common/services/useConfig';

export function useTitleForPartner() {
  const { tenant } = useConfig();

  return {
    getTitle: (title?: string): string | undefined => {
      if (title) {
        return tenant.is.toyota ? title.replace(/Toggle/g, 'Toyota') : title;
      }
      return undefined;
    },
  };
}
